import React from 'react';
import classNames from 'classnames';

import { ScrollArea } from '../ScrollArea';
import { Skeleton } from '../Skeleton';
import { FetchingOverlay } from './components/FetchingOverlay';
import { TableBodySection } from './components/TableBodySection';
import { TableHeadSection } from './components/TableHeadSection';
import { TableLabel } from './components/TableLabel';
import { TablePagination } from './components/TablePagination';
import { useTableContext } from './contexts';

import styles from './Table.module.scss';

export const Table = () => {
    const {
        getAllLeafColumns,
        getCenterTotalSize,
        props: { loading, label, pagination, fetching, bordered, fixedLayout, filterBar },
    } = useTableContext();
    if (loading) return <Skeleton />;

    const showFilterBar =
        filterBar &&
        getAllLeafColumns().some(
            (column) => column.getCanFilter() !== false && column.columnDef.meta?.filtering !== undefined,
        );

    const table = (
        <div
            className={classNames(styles.tableContainer, {
                [styles.bordered]: !!bordered,
            })}
        >
            {label && <TableLabel label={label} />}
            <ScrollArea
                className={classNames(styles.tableWrapper, {
                    [styles.withLabel]: !!label,
                    [styles.withPagination]: !!pagination,
                })}
            >
                <table
                    className={classNames(styles.table, {
                        [styles.fixedLayout]: !!fixedLayout,
                    })}
                    style={{ width: fixedLayout ? undefined : getCenterTotalSize() }}
                >
                    <TableHeadSection />
                    <TableBodySection />
                </table>
                {fetching && <FetchingOverlay />}
            </ScrollArea>
            {pagination && <TablePagination />}
        </div>
    );

    if (!showFilterBar) return table;

    return <div className={styles.tableWithFilterBar}>{table}</div>;
};
